import { useState, useEffect } from "react";
import { Modal, Button, TextField, Box } from "@mui/material";
import AuthService from "services/auth-service";
import { useMaterialUIController, toggleReloadWallets } from "context";

const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
};

const SummaryModal = ({ open, handleClose, wallet }) => {
    const [, dispatch] = useMaterialUIController();

    const [formData, setFormData] = useState({
        from: "",
        wallet_id: null,
    });

    useEffect(() => {
        setFormData({
            from: "",
            wallet_id: wallet ? wallet.id : null,
        });
    }, [wallet]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async () => {
        await AuthService.summariesCalculate(formData);
        toggleReloadWallets(dispatch, Date.now());
        handleClose();
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={modalStyle}>
                <h2>Recalculate summary</h2>
                <TextField
                    label="YYYYMM"
                    name="from"
                    value={formData.from}
                    onChange={handleInputChange}
                    fullWidth
                    margin="normal"
                    type="text"
                />

                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button onClick={handleClose} sx={{ mr: 2 }}>Cancel</Button>
                    <Button onClick={handleSubmit} variant="contained" color="info">Calculate</Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default SummaryModal;
